"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountry = void 0;
const react_1 = require("react");
const LocalizationContext_1 = require("../context/LocalizationContext");
// на втором этапе доработаю (это интерфейс для работы с данным контекстом)
const useCountry = () => {
    const { state } = (0, react_1.useContext)(LocalizationContext_1.LocalizationContext);
    return {
        country: state.country,
        isRussia: state.country === 'ru'
    };
};
exports.useCountry = useCountry;
